import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Global Error Handler for Angular Application
 * 
 * Handles ChunkLoadError which occurs when:
 * - Application is deployed while users have it open
 * - Browser tries to load lazy-loaded chunks with old hash names
 * - Server returns 404 (HTML) instead of the expected JS chunk
 * 
 * Solution: Automatically reload the page to get the new version
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private hasReloaded = false;

  constructor(private injector: Injector) {}

  handleError(error: any): void {
    // Check if this is a ChunkLoadError
    const isChunkLoadError = error?.name === 'ChunkLoadError' || 
                              error?.message?.includes('Loading chunk') ||
                              error?.message?.includes('ChunkLoadError');

    if (isChunkLoadError && !this.hasReloaded) {
      console.warn('⚠️ ChunkLoadError detected - New deployment detected. Reloading page...');
      
      // Set flag to prevent infinite reload loops
      this.hasReloaded = true;
      
      // Store current URL to restore after reload
      const currentUrl = window.location.href;
      const w = window as Window;
      
      // Clear cache and reload
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        }).finally(() => {
          // Force reload with cache bypass
          w.location.replace(currentUrl);
        });
      } else {
        // Fallback if cache API not available
        w.location.replace(currentUrl);
      }
      
      return; // Don't log the error
    }

    // Log other errors to console
    console.error('🔴 Application Error:', error);

    // Re-throw the error if you want it to be caught by other handlers
    // throw error;
  }
}
